import { z } from 'zod';

import { EmailSchema } from './password';

export const LoginSchema = z
  .object({
    email: EmailSchema,
    // Deliberately NOT `PasswordSchema`: a login must not reveal the policy by
    // rejecting a short password differently from a wrong one.
    password: z.string().min(1).max(512),
  })
  .strict();

export type LoginRequest = z.infer<typeof LoginSchema>;

export const RefreshSchema = z
  .object({
    refreshToken: z.string().min(1),
  })
  .strict();

export type RefreshRequest = z.infer<typeof RefreshSchema>;

/** Logout revokes the presented refresh token (and, on reuse, its whole family). */
export const LogoutSchema = RefreshSchema;

export type LogoutRequest = z.infer<typeof LogoutSchema>;
